import { memo } from 'react';
import { Dialog as RACDialog, DialogProps as RACDialogProps } from 'react-aria-components';

import { merge } from '@/components';

export type DialogProps = RACDialogProps;

const IDialog = ({ className, children, ...rest }: DialogProps) => {
  return (
    <RACDialog className={merge('outline-none', className)} {...rest}>
      {children}
    </RACDialog>
  );
};

export const Dialog = memo(IDialog) as typeof IDialog;
